import { Component, Input, OnInit } from '@angular/core';
import { ReturnViewService } from '../../../return-view.service';
import {
  REBATE_CATEGORIES,
  RebateCategory,
  RebateTableColumn,
} from '../../../../constants/rebate-details-constant';

@Component({
    selector: 'app-rebate-detailss-en-v2',
    templateUrl: './rebate-detailss-en-v2.component.html',
    styleUrls: ['./rebate-detailss-en-v2.component.css'],
    standalone: false
})
export class RebateDetailssEnV2Component implements OnInit {
  @Input() returnData: any;
  @Input() printActive: boolean = false;

  rebateData: any = null;
  readonly rebateCategories = REBATE_CATEGORIES;

  constructor(private returnViewService: ReturnViewService) { }

  getValue(item: any, key: string): any {
    return item ? item[key] : null;
  }

  getRows(category: RebateCategory): any[] {
    const rows = this.getValue(this.rebateData, category.key);
    return Array.isArray(rows) ? rows : [];
  }

  hasRebateData(): boolean {
    return this.rebateCategories.some((category) => this.getRows(category).length > 0);
  }

  getColumnTotal(rows: any[], column: RebateTableColumn): number {
    return rows.reduce((sum, row) => sum + this.toNumber(this.getValue(row, column.key)), 0);
  }

  getTotalLabelColumnIndex(columns: RebateTableColumn[]): number {
    const firstAmountIndex = columns.findIndex((column) => column.isAmount);
    return firstAmountIndex > 0 ? firstAmountIndex - 1 : 0;
  }

  getTotalActualInvestment(): number {
    return this.rebateCategories.reduce((total, category) => {
      return total + this.getCategoryAmount(category, category.actualAmountKeys);
    }, 0);
  }

  getTotalAllowableInvestment(): number {
    return this.rebateCategories.reduce((total, category) => {
      const amountKeys = category.allowableAmountKeys && category.allowableAmountKeys.length
        ? category.allowableAmountKeys
        : category.actualAmountKeys;
      return total + this.getCategoryAmount(category, amountKeys);
    }, 0);
  }

  private getCategoryAmount(category: RebateCategory, keys: string[]): number {
    return this.getRows(category).reduce((categoryTotal, row) => {
      return categoryTotal + keys.reduce((rowTotal, key) => {
        return rowTotal + this.toNumber(this.getValue(row, key));
      }, 0);
    }, 0);
  }

  private toNumber(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const numericValue = Number(String(value).replace(/,/g, ''));
    return isNaN(numericValue) ? 0 : numericValue;
  }

  ngOnInit(): void {
    this.rebateData = this.returnData?.rebateData ?? null;
  }

}
